import { createSlice } from "@reduxjs/toolkit";

type State = {
  payload: number[];
};

const slice = createSlice({
  name: "selectedQBCategories",
  initialState: { payload: [] } as State,
  reducers: {
    getSelectedQBCategories: (state, { payload }: { payload: number[] }) => {
      state.payload = payload;
    }
  }
});

export const { getSelectedQBCategories } = slice.actions;
export default slice.reducer;
